// utils/rawbtPrinter.js
export const RawBTPrinter = {
  /**
   * Print plain text via RawBT
   * @param {string} text
   */
  printText: (text) => {
    const encoded = encodeURIComponent(text + "\n\n\n");
    window.location.href = `rawbt:${encoded}`;
  },

  /**
   * Print ESC/POS raw commands (Base64 encoded)
   * Example: Init + Print + Feed
   */
  printEscPos: (commands) => {
    const base64Data = btoa(commands);
    window.location.href = `rawbt:base64,${base64Data}`;
  }
};
